module.exports = __webpack_public_path__ + "mikan.jpg?54898318ebd38ca547f774192a008a16";


//////////////////
// WEBPACK FOOTER
// ./src/mikan.jpg
// module id = 36
// module chunks = 0